/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import template from './sw-cms-el-config-dvsn-form-builder.html.twig';

const { Component, Mixin } = Shopware;

Component.register('sw-cms-el-config-dvsn-form-builder', {
    template,

    mixins: [
        Mixin.getByName('cms-element')
    ],

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.initElementConfig('dvsn-form-builder');
        },
    }
});
